import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const THEME_STORAGE_KEY = 'taigo_theme_mode';
type ThemeMode = 'dark' | 'light';
type RivalGameKey = 'taiko' | 'iidx' | 'popn' | 'sdvx';

interface RivalSlot {
    key: string;
    label: string;
    badge: string;
}

interface RivalGame {
    key: RivalGameKey;
    label: string;
    shortLabel: string;
    slots: RivalSlot[];
}

const RIVAL_GAMES: RivalGame[] = [
    {
        key: 'taiko',
        label: '태고',
        shortLabel: '태고',
        slots: [
            { key: 'taiko', label: '라이벌 1', badge: 'R1' },
            { key: 'taiko2', label: '라이벌 2', badge: 'R2' },
            { key: 'taiko3', label: '라이벌 3', badge: 'R3' }
        ]
    },
    {
        key: 'iidx',
        label: '투덱',
        shortLabel: 'IIDX',
        slots: [{ key: 'iidx', label: '라이벌', badge: 'R' }]
    },
    {
        key: 'popn',
        label: '팝픈',
        shortLabel: '팝픈',
        slots: [{ key: 'popn', label: '라이벌', badge: 'R' }]
    },
    {
        key: 'sdvx',
        label: '사볼',
        shortLabel: 'SDVX',
        slots: [{ key: 'sdvx', label: '라이벌', badge: 'R' }]
    }
];

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.mypage-root {
  min-height: 100vh;
  background: #09090b;
  color: #f4f4f5;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.mypage-root.theme-light {
  background: #f4f4f5;
  color: #18181b;
}

.mypage-wrap {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding-right: 10px;
  padding-left: 10px;
}

.mypage-header {
  position: sticky;
  top: 0;
  z-index: 30;
  border-bottom: 1px solid #27272a;
  background: rgba(24, 24, 27, 0.96);
}

.mypage-root.theme-light .mypage-header {
  border-bottom-color: #d4d4d8;
  background: rgba(250, 250, 250, 0.96);
}

.mypage-header-inner {
  padding-top: 6px;
  padding-bottom: 7px;
}

.mypage-title-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.mypage-title-block {
  min-width: 0;
}

.mypage-title-block h1 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.mypage-title-block p {
  margin: 1px 0 0;
  color: #71717a;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.mypage-root.theme-light .mypage-title-block p {
  color: #71717a;
}

.mypage-nav {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.mypage-icon-btn,
.mypage-nav-link,
.mypage-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #3f3f46;
  border-radius: 8px;
  background: #18181b;
  color: #d4d4d8;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease, opacity 0.16s ease;
}

.mypage-icon-btn {
  width: 30px;
  height: 30px;
  padding: 0;
}

.mypage-icon-btn svg {
  width: 15px;
  height: 15px;
}

.mypage-nav-link {
  height: 30px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.mypage-icon-btn:hover,
.mypage-nav-link:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.mypage-root.theme-light .mypage-icon-btn,
.mypage-root.theme-light .mypage-nav-link {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
}

.mypage-root.theme-light .mypage-icon-btn:hover,
.mypage-root.theme-light .mypage-nav-link:hover {
  border-color: #0891b2;
  color: #0e7490;
}

.mypage-main {
  padding-top: 14px;
  padding-bottom: 44px;
}

.mypage-loading {
  display: grid;
  min-height: 320px;
  place-items: center;
  color: #a1a1aa;
  gap: 10px;
  font-size: 13px;
}

.mypage-spinner,
.mypage-button-spinner {
  display: inline-block;
  border: 2px solid #3f3f46;
  border-top-color: #22d3ee;
  border-radius: 999px;
  animation: mypage-spin 0.8s linear infinite;
}

.mypage-spinner {
  width: 28px;
  height: 28px;
}

.mypage-button-spinner {
  width: 13px;
  height: 13px;
}

.mypage-hero,
.mypage-panel {
  border: 1px solid #27272a;
  border-radius: 8px;
  background: #18181b;
}

.mypage-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
}

.mypage-avatar {
  display: inline-flex;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  align-items: center;
  justify-content: center;
  border: 1px solid #155e75;
  border-radius: 8px;
  background: #164e63;
  color: #ecfeff;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
}

.mypage-hero-main {
  min-width: 0;
}

.mypage-hero-name-row,
.mypage-meta-row {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
}

.mypage-hero-name-row {
  gap: 8px;
}

.mypage-hero-name-row h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.mypage-role {
  display: inline-flex;
  align-items: center;
  border: 1px solid #3f3f46;
  border-radius: 999px;
  background: #27272a;
  color: #a1a1aa;
  padding: 3px 7px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.mypage-role.is-admin {
  border-color: rgba(34, 211, 238, 0.36);
  background: rgba(34, 211, 238, 0.12);
  color: #67e8f9;
}

.mypage-meta-row {
  gap: 6px 12px;
  margin-top: 5px;
  color: #a1a1aa;
  font-size: 12px;
  line-height: 1.25;
}

.mypage-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.mypage-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.76fr);
  gap: 10px;
  margin-top: 10px;
}

.mypage-rival-panel {
  grid-column: 1/-1;
}

.mypage-panel {
  overflow: hidden;
}

.mypage-panel-head {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #27272a;
  padding: 0 14px;
}

.mypage-panel-head h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
}

.mypage-panel-meta {
  color: #71717a;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
}

.mypage-panel-body {
  padding: 14px;
}

.mypage-form {
  display: grid;
  gap: 12px;
}

.mypage-field {
  display: grid;
  gap: 5px;
}

.mypage-label {
  color: #a1a1aa;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.mypage-input {
  display: block;
  width: 100%;
  min-width: 0;
  height: 34px;
  border: 1px solid #3f3f46;
  border-radius: 8px;
  background: #09090b;
  color: #f4f4f5;
  padding: 0 10px;
  font-size: 13px;
  line-height: 1;
  outline: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.mypage-input:focus {
  border-color: #22d3ee;
}

.mypage-input:disabled {
  background: #27272a;
  color: #a1a1aa;
}

.mypage-input::placeholder {
  color: #71717a;
}

.mypage-panel-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #27272a;
  background: #111113;
  padding: 10px 14px;
}

.mypage-action {
  min-width: 72px;
  height: 32px;
  gap: 6px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
}

.mypage-action:disabled {
  cursor: wait;
  opacity: 0.58;
}

.mypage-action.is-primary {
  border-color: #155e75;
  background: #164e63;
  color: #ecfeff;
}

.mypage-action.is-primary:hover:not(:disabled) {
  border-color: #22d3ee;
  color: #ffffff;
}

.mypage-action.is-secondary {
  border-color: #3f3f46;
  background: #27272a;
  color: #e4e4e7;
}

.mypage-action.is-secondary:hover:not(:disabled) {
  border-color: #71717a;
  color: #ffffff;
}

.mypage-action.is-danger {
  border-color: #7f1d1d;
  background: #991b1b;
  color: #fee2e2;
}

.mypage-action.is-danger:hover:not(:disabled) {
  border-color: #f87171;
  color: #ffffff;
}

.mypage-rival-game-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.mypage-rival-game-tab {
  display: inline-flex;
  min-width: 0;
  height: 36px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid #3f3f46;
  border-radius: 8px;
  background: #111113;
  color: #a1a1aa;
  padding: 0 10px;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.mypage-rival-game-tab:hover {
  border-color: #71717a;
  color: #f4f4f5;
}

.mypage-rival-game-tab.is-active {
  border-color: #22d3ee;
  background: rgba(34, 211, 238, 0.12);
  color: #67e8f9;
}

.mypage-rival-game-label,
.mypage-rival-game-count {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mypage-rival-game-label {
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
}

.mypage-rival-game-count {
  color: inherit;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  opacity: 0.78;
}

.mypage-rival-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mypage-rival-item {
  display: grid;
  grid-template-columns: 48px minmax(78px, 0.28fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #27272a;
  border-radius: 8px;
  background: #111113;
  padding: 8px;
}

.mypage-rival-badge {
  display: inline-flex;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid #155e75;
  border-radius: 8px;
  background: rgba(34, 211, 238, 0.1);
  color: #67e8f9;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.mypage-rival-name {
  overflow: hidden;
  color: #d4d4d8;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mypage-rival-remove {
  display: inline-flex;
  width: 46px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #3f3f46;
  border-radius: 8px;
  background: #18181b;
  color: #a1a1aa;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.mypage-rival-remove:hover:not(:disabled) {
  border-color: #f87171;
  color: #fecaca;
}

.mypage-rival-remove:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.mypage-rival-tools {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.mypage-root.theme-light .mypage-hero,
.mypage-root.theme-light .mypage-panel {
  border-color: #d4d4d8;
  background: #ffffff;
}

.mypage-root.theme-light .mypage-panel-head,
.mypage-root.theme-light .mypage-panel-actions {
  border-color: #e4e4e7;
}

.mypage-root.theme-light .mypage-panel-actions,
.mypage-root.theme-light .mypage-rival-item {
  background: #f7f7f8;
}

.mypage-root.theme-light .mypage-role {
  border-color: #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
}

.mypage-root.theme-light .mypage-role.is-admin {
  border-color: rgba(8, 145, 178, 0.32);
  background: #ecfeff;
  color: #0e7490;
}

.mypage-root.theme-light .mypage-meta-row,
.mypage-root.theme-light .mypage-label,
.mypage-root.theme-light .mypage-panel-meta {
  color: #52525b;
}

.mypage-root.theme-light .mypage-input {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #18181b;
}

.mypage-root.theme-light .mypage-input:focus {
  border-color: #0891b2;
}

.mypage-root.theme-light .mypage-input:disabled {
  background: #f4f4f5;
  color: #71717a;
}

.mypage-root.theme-light .mypage-rival-item {
  border-color: #e4e4e7;
}

.mypage-root.theme-light .mypage-rival-game-tab {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

.mypage-root.theme-light .mypage-rival-game-tab:hover {
  border-color: #0891b2;
  color: #0e7490;
}

.mypage-root.theme-light .mypage-rival-game-tab.is-active {
  border-color: #0891b2;
  background: #ecfeff;
  color: #0e7490;
}

.mypage-root.theme-light .mypage-rival-name {
  color: #18181b;
}

.mypage-root.theme-light .mypage-rival-badge {
  border-color: #0891b2;
  background: #ecfeff;
  color: #0e7490;
}

.mypage-root.theme-light .mypage-action.is-secondary,
.mypage-root.theme-light .mypage-rival-remove {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

@keyframes mypage-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .mypage-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .mypage-title-line {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .mypage-nav {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 1px;
  }
  .mypage-hero {
    align-items: flex-start;
  }
  .mypage-rival-game-tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mypage-rival-item {
    grid-template-columns: 48px minmax(0, 1fr) 46px;
  }
  .mypage-rival-item .mypage-input {
    grid-column: 1/-1;
  }
  .mypage-rival-tools {
    justify-content: stretch;
  }
  .mypage-rival-tools .mypage-action {
    width: 100%;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;
    public rivalGames: RivalGame[] = RIVAL_GAMES;
    public activeRivalGameKey: RivalGameKey = 'taiko';
    public rivalEntriesByGame: any = {};
    public savingRivals: boolean = false;
    public themeMode: ThemeMode = 'dark';

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.themeMode = this.loadThemeMode();
        this.applyThemeMode();
        await this.service.init();
        await this.service.auth.allow("/auth");
        await this.load();
    }

    public getThemeToggleLabel(): string {
        return this.themeMode === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환';
    }

    public async toggleThemeMode() {
        this.themeMode = this.themeMode === 'dark' ? 'light' : 'dark';
        try {
            localStorage.setItem(THEME_STORAGE_KEY, this.themeMode);
        } catch { }
        this.applyThemeMode();
        await this.service.render();
    }

    public getUserInitial(): string {
        const source = String(this.user?.name || this.user?.email || '?').trim();
        return source ? source.charAt(0).toUpperCase() : '?';
    }

    public getPublicId(): string {
        return String(this.user?.public_id || this.user?.publicId || '');
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
            this.rivalEntriesByGame = this.normalizeRivalEntriesByGame(data?.rivals);
        }
        await this.service.render();
    }

    private normalizeRivalEntriesByGame(rivals: any = {}): any {
        const result: any = {};

        for (const game of this.rivalGames) {
            const entries = game.slots
                .map((slot) => String(rivals?.[slot.key] || '').trim())
                .filter((value) => !!value)
                .slice(0, game.slots.length);
            result[game.key] = entries.length > 0 ? entries : [''];
        }

        return result;
    }

    private getRivalPayload() {
        const payload: any = {};
        for (const game of this.rivalGames) {
            const values = (this.rivalEntriesByGame[game.key] || [])
                .map((value: any) => String(value || '').trim())
                .filter((value: string) => !!value)
                .slice(0, game.slots.length);

            for (let i = 0; i < game.slots.length; i++) {
                payload[game.slots[i].key] = values[i] || '';
            }
        }
        return payload;
    }

    private loadThemeMode(): ThemeMode {
        try {
            const saved = localStorage.getItem(THEME_STORAGE_KEY);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch { }
        return 'dark';
    }

    private applyThemeMode() {
        try {
            document.documentElement.setAttribute('data-taigo-theme', this.themeMode);
            document.documentElement.style.colorScheme = this.themeMode;
        } catch { }
    }

    public async updateProfile() {
        if (!this.user.name) {
            await this.service.modal.error("닉네임을 입력해주세요.");
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("update_profile", {
            name: this.user.name
        });

        await this.service.sleep(500);
        this.saving = false;

        if (code === 200) {
            this.user = data || this.user;
            await this.service.modal.success("프로필이 업데이트되었습니다.");
        } else {
            await this.service.modal.error(data?.message || data || "업데이트에 실패했습니다.");
        }
        await this.service.render();
    }

    public async saveRivals() {
        this.savingRivals = true;
        await this.service.render();

        const payload = this.getRivalPayload();
        const { code, data } = await wiz.call("update_rivals", {
            rivals: JSON.stringify(payload)
        });

        await this.service.sleep(500);
        this.savingRivals = false;

        if (code === 200) {
            this.rivalEntriesByGame = this.normalizeRivalEntriesByGame(data?.rivals || payload);
            if (this.user) {
                this.user.rivals = data?.rivals || payload;
            }
            await this.service.modal.success("라이벌 설정이 저장되었습니다.");
        } else {
            await this.service.modal.error(data?.message || data || "라이벌 설정 저장에 실패했습니다.");
        }
        await this.service.render();
    }

    public getActiveRivalGame(): RivalGame {
        return this.rivalGames.find((game) => game.key === this.activeRivalGameKey) || this.rivalGames[0];
    }

    public getActiveRivalEntries(): string[] {
        const entries = this.rivalEntriesByGame[this.activeRivalGameKey];
        if (Array.isArray(entries)) return entries;
        this.rivalEntriesByGame[this.activeRivalGameKey] = [''];
        return this.rivalEntriesByGame[this.activeRivalGameKey];
    }

    public getActiveRivalLimit(): number {
        return this.getActiveRivalGame().slots.length;
    }

    public getActiveRivalCount(): number {
        return this.getRivalGameCount(this.getActiveRivalGame());
    }

    public getRivalGameCount(game: RivalGame): number {
        const entries = this.rivalEntriesByGame[game.key] || [];
        return entries.filter((value: any) => !!String(value || '').trim()).length;
    }

    public getRivalInputLabel(index: number): string {
        const game = this.getActiveRivalGame();
        const slot = game.slots[index] || game.slots[0];
        return `${game.label} ${slot.label}`;
    }

    public getRivalInputBadge(index: number): string {
        const game = this.getActiveRivalGame();
        const slot = game.slots[index] || game.slots[0];
        return slot?.badge || `R${index + 1}`;
    }

    public async selectRivalGame(key: RivalGameKey) {
        if (this.activeRivalGameKey === key) return;
        this.activeRivalGameKey = key;
        this.getActiveRivalEntries();
        await this.service.render();
    }

    public canAddRival(): boolean {
        return this.getActiveRivalEntries().length < this.getActiveRivalLimit();
    }

    public async addRival() {
        if (!this.canAddRival()) return;
        this.getActiveRivalEntries().push('');
        await this.service.render();
    }

    public async removeRival(index: number) {
        const entries = this.getActiveRivalEntries();
        if (entries.length <= 1) {
            entries[0] = '';
        } else {
            entries.splice(index, 1);
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error("현재 비밀번호를 입력해주세요.");
            return;
        }
        if (!new_password) {
            await this.service.modal.error("새 비밀번호를 입력해주세요.");
            return;
        }
        if (new_password.length < 8) {
            await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error("새 비밀번호가 일치하지 않습니다.");
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call("change_password", {
            current_password: current_password,
            new_password: new_password
        });

        await this.service.sleep(500);
        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success("비밀번호가 변경되었습니다.");
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            await this.service.modal.error(data?.message || data || "비밀번호 변경에 실패했습니다.");
        }
        await this.service.render();
    }
}

export default PageMypageComponent;